import { fieldsConnect } from "@/locale/modules/index";
import common from "@/locale/modules/common";

const title = ["合约主题", "Title"];

const SMS = ["短信验证", "SMS"];

const contract = {
  SaveDraft: ["保存草稿", "Save Draft"],
  SaveAndSend: ["保存并发起", "Save and Send"],
  Title: title,
  PleaseEnterTitle: fieldsConnect(common, ["PleaseEnter", title]),
  UploadFile: fieldsConnect(common, ["Upload", "Space", "File"]),
  SelectFile: fieldsConnect(common, ["Select", "Space", "File"]),
  UploadFileTip1: ["上传文件大小不超过20M", "File size limit is 20M"],
  UploadFileTip2: ["上传文件类型需为pdf,doc,docx,xls,xlsx,jpg,png,gif", "File type accepted are pdf, doc, docx, xls, xlsx, jpg, png, gif"],
  AttachmentTip: ["此项为非必选项目", "Attachment is option"],
  PleaseEnterRemark: fieldsConnect(common, ["PleaseEnter", "Remark"]),
  SortByCreateFarthest: ["按合约创建时间顺序", "Sort by create, Farthest"],
  SortByCreateNewest: ["按合约创建时间倒序", "Sort by create, Newest"],
  SortByModifyFarthest: ["按合约修改时间顺序", "Sort by modify, Farthest"],
  SortByModifyNewest: ["按合约修改时间倒序", "Sort by modify, Newest"],
  SortByContractValidityFarthest: ["按合约有效期顺序", "Sort by contract validity, Farthest"],
  SortByContractValidityNewest: ["按合约有效期倒序", "Sort by contract validity, Newest"],
  PleaseEnterTitleSearch: fieldsConnect(common, ["PleaseEnter", ["要查找的合约主题", "title to search"]]),
  ContractNo: ["合约编号", "Contract No"],
  ContractTitle: ["合约主题", "Contract Title"],
  CreateBy: ["创建人", "Create By"],
  DocName: ["文档名称", "Doc Name"],
  CreateTime: ["创建时间", "Create Time"],
  DownloadCA: ["CA合约", "CA"],
  DownloadNormal: ["普通合约", "Normal"],
  Read: ["已读", "Read"],
  UnRead: ["未读", "UnRead"],
  DelCompt: ["彻底删除", "Del Compt"],
  ContractContentValidation: ["合约内容区块链验证", "Contract Content Validation"],
  ContractStampValidation: ["签章内容区块链验证", "Contract Stamp Validation"],
  ContractKeyDataValidation: ["关键数据区块链验证", "Contract Key Data Validation"],
  AreYouSureDelete: fieldsConnect(common, ["AreYouSure", ["删除合约至垃圾箱吗?", "delete the contract?"]]),
  AreYouSureDeleteCompletely: fieldsConnect(common, ["AreYouSure", ["彻底删除该合约吗?", "delete this contract completely?"]]),
  Draft: ["草稿", "Draft"],
  Completed: ["已完成", "Completed"],
  Signing: ["签署中", "Signing"],
  Expired: ["已过期", "Expired"],
  Terminated: ["已终止", "Terminated"],
  Rejected: ["拒绝", "Rejected"],
  Send: ["发起", "Send"],
  Sign: ["签署", "Sign"],
  WaitingForSignature: ["等待签署", "Waiting for signature"],
  Status: ["签署状态", "Status"],
  ExpirationTime: ["有效期", "Expiration Time"],
  SigningParty: ["签署方式", "Signing Party"],
  MultiParty: ["多方签署", "Multi Party"],
  ReceivingParty: ["对方签署", "Receiving Party"],
  SendingParty: ["本人签署", "Sending Party"],
  Authentication: ["认证要求", "Authentication"],
  SMS,
  SMSName: fieldsConnect(common, [SMS, "PlusCode", ["手机实名", "NameAuthenticated"]]),
  EmailAuth: ["邮箱认证", "Email authentication"],
  FaceAuthentication: ["人脸核身", "Face authentication"],
  SigningMode: ["签署模式", "Signing Mode"],
  Recipient: ["签署方", "Recipient"],
  Disorder: ["无序签署", "Disorder"],
  Order: ["有序签署", "Order"],
  SigningTime: ["签署时间", "Signing Time"],
  Remark: ["签署备注", "Remark"],
  Contact: ["请联系客服开通", "contact 4008862808"],
  AddRecipient: ["添加签署方", "Add recipient"],
  AddFromMyDirectory: ["从个人通讯录中选择", "Add from my directory"],
  AddFromCoDirectory: ["从企业通讯录中选择", "Add from co. directory"],
  ChooseRecipient: fieldsConnect(common, ["Choose", "Space", ["用户", "Recipient"]]),
  DefaultSignature: ["默认签章", "Default signature"],
  CorporateSeal: ["企业签章", "Corporate Seal"],
  TimeStamp: ["时间戳", "Time Stamp"],
  Customization: ["自定义", "Customization"],
  StraightLine: ["直线", "Straight Line"],
  Curve: ["曲线", "Curve"],
  Circle: ["圆形", "Circle"],
  CustomStamp: ["自定义印章", "Custom Stamp"],
  GraphicStamp: ["图形印章", "Graphic Stamp"],
  SigningInformation: ["签署信息", "Signing Information"],
  AreYouSureToSign: ["是否确定签署", "Are you sure to sign"],
  SigningContract: ["签署合约", "Signing"],
  SigningReason: ["签署理由", "Signing Reason"],
  ContractValidity: ["合约有效期", "Contract validity"],
  TobeSignedBy: ["待签署人", "To be signed by"],
  RejectedTime: ["拒绝时间", "rejected time"],
  RejectedReason: ["拒绝理由", "rejected reason"],
  Rejector: ["拒绝方", "Rejector"],
  AddContract: ["添加合约", "Add contract"],
  LocalUpload: ["本地上传", "Local upload"],
  NetDisk: ["网盘选择", "Net disk"],
  UploadAttachment: fieldsConnect(common, ["Upload", "Attachment"]),
  DirectlyInitiated: ["直接发起", "Directly Initiated"],
  SpecifySigningLocation: ["指定签署位置", "Specify signing location"],
  Deadline: ["截止时间", "Deadline"],
  RealNameAuthenticationNotCompleted: ["未完成实名认证", "Real-name authentication not completed"],
  RealNameAuthentication: ["实名认证", "real-name authentication"],
  Tips: ["温馨提示", "Tips"],
  RealNameAuthenticationTip1: [
    "为保障您的身份真实有效，签署结果具有法律效力，建议您完成个人实名认证",
    "In order to ensure that your identity is true and valid, and the signing result has legal effect, we recommend that you complete personal real-name authentication",
  ],
  RealNameAuthenticationTip2: [
    "您的身份信息仅用于个人实名认证服务，我们采用了各种安全技术来确保您的个人信息不被泄露和未经授权的使用",
    "Your identity information is only used for personal real-name authentication services, and we use various security technologies to ensure that your personal information is not leaked and used without authorization",
  ],
  ToBeSigned: ["我签署的", "I signed"],
  MyInitiation: ["我发起的", "My initiation"],
  PleaseSelectContractType: ["请选择合约类型", "Please select contract type"],
  OrdinaryContract: ["普通合约", "Ordinary contract"],
  ExternalContract: ["外部合约", "External contract"],
  Withdraw: ["撤回", "withdraw"],
  Reject: ["拒绝", "reject"],
  Terminate: ["终止", "Terminate"],
  RequiredContent: ["必填内容", "Required content"],
  CreateContractUploadFileTip1: ["1. 上传文件大小不超过50M", "1. The upload file size does not exceed 50M"],
  CreateContractUploadFileTip2: [
    "2. 上传文件类型需为pdf,doc,docx,xls,xlsx,jpg,png,gif",
    "2. The upload file types must be pdf, doc, docx, xls, xlsx, jpg, png, gif",
  ],
  CreateContractUploadFileTip3: [
    "3. pdf、doc、docx、xls、xlsx格式的文件仅允许上传一份；图片格式可上传多张，按顺序展示至同一合约内。",
    "3. PDF, Doc, Docx, xlx, xlxs format files are only allowed to upload one copy; Multiple images can be uploaded and displayed in the same contract in order.",
  ],
  VerifyTheRealNameOfTheMobilePhone: ["手机实名", "Verify the real name of the mobile phone "],
  NoRealNameRequired: ["不验证实名", "No real name required"],
  OptionalContent: ["选填内容", "Optional content"],
  NoticeReminder: ["通知与提醒","Notice Reminder"],
  SigningCompCompletionReminder: ["签署完成提醒", "Signing completion re,omder"],
  SwitchTurnedOnAfterContractSigned: ["开关开启后将在合约完成签署后","Switch turned on after contract signed"],
  SendNotificationTaskToTheDesignatedUser: ["对指定用户发送知会任务","Send notification task to the designated user"],
  UsersBroughtOutByDefaultCanBeModified: ["默认带出的用户可修改","User brought out by default can be modified"],
  TransmissionWillBeSentIfTheSwitchIsTurnedOff: ["开关关闭则不发送","Transmission will be sent if the switch is turned off"],
  ContractIsEffectiveOnly: ["设置后仅对本合约生效","Contract is effective only"],
  AddUser: ["添加用户","Add user"],
  NotificationTypeIsNotificationTypeTask: ["通知类型为知会型待办任务","Notification type is notification task"],
  DisplayedInUserWorkbenchToDoList: ["显示在用户工作台待办中","Displayed in user workbench to do list"],
  OnlyThoseAlreadyEnabledThaiSelectionAreSupported: ["仅支持选择已开通签泰的","Only those already enabled thai selection are supported"],
  HaveSelected:["已选择","Have selected"],
  Cancel:["取消","Cancel"],
  Confirm:["确定","Confirm"],
  Save:["保存","Save"],
  Editor: ["编辑","Editor"],
  CreateContractUploadAppendFileTip1: ["1. 上传文件大小不超过20M", "1. The upload file size does not exceed 20M"],
  CreateContractUploadAppendFileTip2: ["2. 附件无需签署", "2. Attachments do not need to be signed"],
  ValidPeriodExpired: ["有效期已过期", "Valid period expired"],
  Name: ["姓名", "Name"],
  MobilePhoneNumber: ["手机号", "Mobile phone number"],
  Email: ["邮箱号", "Email"],
  Organization: ["组织", "Organization"],
  Remarks: ["备注", "Remarks"],
  PleaseEnterASearchKeyword: ["请输入搜索关键字", "Please enter a search keyword"],
  PersonalVersionOfSignTrust: ["签泰个人版", "Personal version of SignTrust"],
  SaveAndInitiate: ["保存并直接发起", "Save and initiate"],
  SaveAndSpecifySigningLocation: ["保存并指定签署位置", "Save and specify signing location"],
  SelectDesignatedSignatory: ["选择指定签署方", "Select Designated Signatory"],
  ViewAll: ["查看全部", "View all"],
  Required: ["必填", "Required"],
  BatchOperation: ["批量操作", "Batch operation"],
  HasBeenRejected: ["已被拒绝", "Has been rejected"],
  MyRejected: ["我已拒绝", "Rejected"],
  UploadContract: ["上传合约", "Upload contract"],
  ReUploadContract: ["重新上传合约", "Re upload contract"],
  SignDetails: ["签署详情", "Sign Details"],
  FileProcessing: ["文件处理中", "File processing"],
  DoYouWantToDeleteThisFile: ["是否要删除该文件？", "Do you want to delete this file?"],
  FileLoading: ["文件加载中", "File loading"],
  AddSignature: ["添加签名", "Add signature"],
  Signature: ["签署项", "Signature"],
  PersonalSignature: ["个人签章", "Personal signature"],
  Timestamp: ["时间戳", "timestamp"],
  RideTheSewingBadge: ["骑缝章", "Ride the sewing badge"],
  Tool: ["工具", "Tool"],
  Delete: ["删除", "Delete"],
  Page: ["页数", "Page"],
  SignAndSend: ["签署并发送合约", "Sign and send"],
  VCode: ["验证码", "Vcode"],
  Password: ["密码", "Password"],
  SignPassword: ["签署密码", "Sign Password"],
  PleaseSelectAValidPeriod: ["请选择有效期", "Please select a valid period"],
  PleaseCompleteTheRealNameAuthenticationFirst: ["请先完成实名认证", "Please complete the real-name authentication first."],
  PleaseCompleteEmailAuthenticationFirst: ["请先完成实名认证", "Please complete email authentication first."],
  SignerSMobilePhoneNumberIsWrongPleaseCheck: [
    "第 {number} 位签署人手机号有误，请检查",
    "Signer {number}'s mobile phone number is wrong, please check",
  ],
  PleaseDragTheSignatureIntoTheFile: ["请将签章拖动到文件内", "Please drag the signature into the file"],
  SuccessfulInitiation: ["发起成功", "Successful initiation"],
  InitiationFailed: ["发起失败", "Initiation failed"],
  SuccessfullySigned: ["签署成功", "Successfully signed"],
  SigningFailed: ["签署失败", "Signing failed"],
  SignerUserNameNoSignatureAdded: ["签署方{userName}，未添加签署项", "Signer {userName}, no signature added"],
  CancelBatch: ["取消批量", "Cancel batch"],
  BatchDeletion: ["批量删除", "batch deletion"],
  PleaseClickSignToSign: ["请点击签署项进行签署", "Please click Sign to sign"],
  SignedOn: ["签署于", "Signed on"],
  ModifyFormat: ["修改格式", "Modify format"],
  PleaseSignRequiredField: ["请签署必填项", "Please sign required field"],
  CustomText: ["自定义文字", "Custom text"],
  CustomImage: ["自定义图片", "Custom image"],
  TextColor: ["文字颜色", "Text Color"],
  Optional: ["非必填", "Optional"],
  BatchDownloadOfCaContracts: ["批量下载CA合约", "Batch download of CA contracts"],
  BatchDownloadOfRegularContracts: ["批量下载普通合约", "Batch download of regular contracts"],
  ValidateContract: ["验证合约", "Validate contract"],
  Transfer: ["转移", "transfer"],
  InitiateOnly: ["仅发起", "Initiate only"],
  FileName: ["文件名称", "File Name"],
  PleaseUploadTheFile: ["请上传文件", "Please upload the file"],
  PleaseAddSignatory: ["请添加签署方", "Please add signatory"],
  VerifyContract: ["验证合约", "Verify contract"],
  VerifyQRCode: ["验证二维码", "Verify QR code"],
  OpenStatus: ["开放状态", "Open status"],
  SecuritySettings: ["安全设置", "Security Settings"],
  Public: ["公开", "public"],
  PasswordValidation: ["密码验证", "Password validation"],
  UpdatePassword: ["更新密码", "Update password"],
  SelectDate: ["选择日期", "Select date"],
  VerifyQRCodeTip1: [
    "开关开启后将在合约最后生成验证二维码页面，支持扫码查看合约详情",
    "After the switch is turned on, a verification QR code page will be generated at the end of the contract, and you can scan the code to view the contract details.",
  ],
  VerifyQRCodeTip2: [
    "开关关闭则二维码不开放扫码，开启开关重新开启扫码",
    "If the switch is turned off, the QR code will not be scanned. If the switch is turned on, the QR code will be scanned again.",
  ],
  VerifyQRCodeTip3: ["允许所有人扫码，不校验身份", "Allow everyone to scan the QR code without verifying identity"],
  VerifyQRCodeTip4: ["扫码后输入密码查看", "Scan the code and enter the password to view"],
};

export default contract;
